export default {
  "home": {
    "title": "Hey you found the MyBikeSetup WebApp, and now?",
    "mainmessage": "Beside our <a href=\"https://play.google.com/store/apps/details?id=net.byte_welt.eagleeye.mybikesetup\" target=\"_blank\">Android App</a> now there is this WebApp.<br>Since we are, well me, currently only maintain the Android, there is this web app for all other platforms. If your browser works fine, you have the same features as Android. In addition, the app should be running without an internet connection, unless you have safari ...<br>But you can store your data on the server, like in the Android App, also sync with this app.",
    "initial_question": "There is no local configuration, what sould happen:<br>Do you have a user id, then enter it:",
    "noconfig_answer": "You hasn't something? Then create here some sample configuration",
    "existing_configmsg": "Oh there is a configuration, let's go.",
    "components": {
      "load_configuration": "Load configuration",
      "create_new": "Create new"
    }
  },
  "menu": {
    "spring_calculator": "Spring Calculator",
    "spoke_calculator": "Spoke Calculator"
  },
  "app": {
    "menu": {
      "clear_storage": "Clear storage",
      "refresh": "Refresh",
      "bookmark": "Bookmark/Share",
      "save_toserver": "Save to server"
    },
    "dialog": {
      "store_title": "Store everything on server?",
      "store_msg": "If you aggree all configurations will be stored on a server and could be accessed by the user id. <br>Besite the configuration, no data will be stored. For backup purposes store your user id, later you can add these backup to an other device or reload for backup.<br>If you disagree, every stays only stored in your browser and will be deleted if you erased your browser local storage.",
      "delete_start": "Should this",
      "delete_end": "really been deleted? ",
      "delete_title": "Delete",
    }
  },
  "todo": {
    "addfab": "Add ToDo",
    "editbtn": "Edit ToDo",
    "dialog": {
      "edittitle": "Edit ToDo",
      "newtitle": "New ToDo",
    }
  },
  "setup": {
    "setuptitle": "Setup title",
    "menu": {},
    "setupitem": {
      "selecttype": "Select type",
    }
  },
  "calc": {
    "title": "Spring calculator",
    "topmsg": "To calculate your spring rate, you need to enter some details. The result is a theoretical calculated recommendation, it can vary by your personal preferences and your bike. If you ride a very heavy bike, like an ebike you should add some additional weight, depending of motor and battery 3-8kg.",
    "riderweight": "Rider weight",
    "shockstroke": "Shock stroke",
    "wheeltravel": "Wheel travel",
    "singlepivot_title": "Singlepivot/DW-Link",
    "vpp_title": "4 Bar/VPP/4 Link",
    "results": "Results",
    "sag": {
      "label": "Sag",
      "plush": "Plush",
      "firm": "Firm"
    }
  },
  "setuptype": {
    "pressure": "Pressure",
    "spring": "Spring",
    "tire_front": "Tire front",
    "tire_rear": "Tire rear",
    "pressure_front": "Pressure front",
    "pressure_rear": "Pressure rear",
    "chainring": "Chainring"
  },
  "errormsg": {
    "minlength": "Minimum length is 3 characters",
    "required": "This field is required"
  },
  "spoke": {
    "title": "Spoke Calculator",
    "hub_title": "Hub",
    "hub_manufacturers_select": "Manufacturer",
    "hub_select_title": "Model",
    "rim_title": "Rim",
    "rim_manufacturers_select": "Manufacturer",
    "rim_select_title": "Model",
    "hub_rear": "rear",
    "hub_front": "front",
    "result_title": "Result",
    "spoke_count": "Spoke count",
    "spoke_crossing": "Spoke crossing",
    "spoke_length_left": "Spoke length left:",
    "spoke_length_right": "Spoke length right:",
    "exact": "exact",
    "recommended": "recommended"
  },
  "inprint": {"title": "Inprint"},
  "noDataText": "No data available",
  "agree": "Agree",
  "disagree": "Disagree",
  "ok": "OK",
  "cancel": "Cancel",
  "delete": "Delete",
  "fork": "Fork",
  "shock": "Shock",
  "misc": "Misc",
  "add_bike": "Add bike",
  "edit": "Edit",
  "new": "New",
  "duplicate_setup": "Duplicate setup",
  "delete_setup": "Delete setup",
  "rename_setup": "Rename setup",
  "delete_bike": "Delete bike",
  "edit_bike": "Edit bike",
  "edit_setup": "Edit setup",
  "new_setup": "New Setup",
  "save": "Save"
}



//////////////////
// WEBPACK FOOTER
// ./src/locale/en.ts
// module id = 73
// module chunks = 9